export const HEADER_CONTENT_TYPE = 'Content-Type';
export const HEADER_AUTHORIZATION = 'Authorization';
export const HEADER_TENANT = 'X-Tenant';
export const HEADER_CHAT_SESSION_ID = 'X-Chat-Session-Id';
export const HEADER_CHAT_SESSION_ID_GENERATED = 'x-chat-session-id-generated';
export const HEADER_CHAT_SESSION_EXPIRED = 'x-chat-session-expired';
